import { io } from 'socket.io-client'
import store from '../store'
import config from '../config/services'

let socket: any
let connectionState = 0

 async function init(jwt: string){
  try {
  if(!jwt){
    return console.error('Socket init called with empty jwt')
  }

  if(connectionState > 0 ){
    return console.info('Socket already initialised')
  }
  connectionState = 1
  const authState = await store.dispatch('auth/get')
  socket = io(config.Sockets, {
    path: '/sockets/socket.io',
    query: {
      authorization: `Bearer ${jwt}`,
      path: '/sockets/socket.io',
      source: 'WEB_USER',
      channel: 'APP',
      version: '2021-07-28',
      authClassId: authState?.companyId
    },
    withCredentials: true,
    transports: ['websocket'],
  })

  socket.on('connect', () => {
    console.log('Socket Connected', socket.id)
    // state.connected = true
    connectionState = 2
  })
  
  socket.on('connect_error', reason => {
    console.log('Socket Connect Error: ', reason)
    connectionState = 0
  })

  socket.on('disconnect', reason => {
    console.log('Socket Disconnect: ', reason )
    connectionState = 0
  })
} catch(error){
    console.error('Socket Error',error)
}
}

async function close(){
  await socket.disconnect()
  await socket.close()
  connectionState = 0
}

export default {
  init,
  close
}